import { useState } from "react";
import { getQueryParam, updateQueryParam } from "shared/lib";
import { DatePickerValue } from "shared/ui";

export interface DateFilters {
  dateGreater: string | null;
  dateLesser: string | null;
  handleDateGreater: (date: DatePickerValue, dateString: string) => void;
  handleDateLesser: (date: DatePickerValue, dateString: string) => void;
  clearDates: () => void;
  isDataFilterActive: boolean;
}

export const useDateFilters = (): DateFilters => {
  const [dateGreater, setDateGreater] = useState<string | null>(
    getQueryParam("dateGreater") || null
  );
  const [dateLesser, setDateLesser] = useState<string | null>(
    getQueryParam("dateLesser") || null
  );

  const handleDateGreater = (_: DatePickerValue, dateString: string) => {
    setDateGreater(dateString);
    updateQueryParam("dateGreater", dateString);
  };

  const handleDateLesser = (_: DatePickerValue, dateString: string) => {
    setDateLesser(dateString);
    updateQueryParam("dateLesser", dateString);
  };

  const clearDates = () => {
    setDateGreater(null);
    setDateLesser(null);
    updateQueryParam("dateGreater");
    updateQueryParam("dateLesser");
  };

  const isDataFilterActive = !!dateGreater || !!dateLesser;

  return {
    dateGreater,
    dateLesser,
    handleDateGreater,
    handleDateLesser,
    clearDates,
    isDataFilterActive,
  };
};
